module.exports = __webpack_public_path__ + "img/Padding Group 13 (1).dd199524.png";